export function emailValidator(email) {
    if(email){
        if(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email))
          return true;
        else
          return 'Email address is invalid.'
      }else
          return 'Email address is required.'
}